import { doRequest } from '@r1-frontend/do-request';
import { requestByConnection, ResponseDto } from '@r1-frontend/api-domru/api-request/v1/user/request-by-connection';

import { ISubmitParam } from '@r1-frontend/ui-react/components/popups/popupCallback';
import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';
import { CATEGORIES } from '@r1-frontend/shared/constants/analytics';

import { TContextDispatch } from '~/src/components/ConnectDomruPopup/context';
import { setResult, setView } from '~/src/components/ConnectDomruPopup/context/actions';
import { TInitialState } from '~/src/components/ConnectDomruPopup/context/initialState';
import { getSelectedProductsIds } from '~/src/components/ConnectDomruPopup/context/selectors';
import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';

export const sendRequest = (clientData: ISubmitParam, csrf: string) => async(dispatch: TContextDispatch, getState: () => TInitialState) => {
    const state = getState();
    const selectedProductsIds = getSelectedProductsIds(state);

    const resp = await doRequest.apiRequest<ResponseDto>(
        requestByConnection({
            fio: clientData.fio || 'Потенциальный клиент сайта',
            phone: clientData.phone,
            check_call_type: window.location.pathname,
            product_id: selectedProductsIds,
            csrf,
        }),
    );

    if (resp.isSuccess) {
        const { status, message, request_id: requestId = null } = resp.payload;
        const ok = !!status;

        dataLayerForCBPhonePush({
            action: ok ? 'finished' : 'error',
            option: `${selectedProductsIds.join(',')}${ok ? '' : ' | ' + message}`,
            requestId,
            isPopup: true,
            category: CATEGORIES.applicationFormHeader,
        });
        dispatch(setResult({
            status: ok ? EResultPopupStatus.SUCCESS : EResultPopupStatus.ERROR,
            message,
        }));
    } else {
        dataLayerForCBPhonePush({
            action: 'error',
            isPopup: true,
            requestId: null,
            category: CATEGORIES.applicationFormHeader,
        });
        dispatch(setResult({
            status: EResultPopupStatus.ERROR,
            message: resp.error.message,
        }));
    }

    dispatch(setView('result'));
};
